require('../../modules/es.map');
require('../../modules/esnext.map.find-key');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Map', 'findKey');
